/**
 * Helper function to build image URL that works in both dev and production
 * @param imagePath - The image path from the API response (can be relative or absolute)
 * @returns The complete image URL
 */
export const buildImageUrl = (imagePath: string): string => {
    if (!imagePath) return '';

    // If the URL is already absolute (starts with http:// or https://), return it as-is
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        return imagePath;
    }

    // Priority 1: Use dedicated media URL environment variable if available
    if (process.env.REACT_APP_MEDIA_URL) {
        const mediaUrl = process.env.REACT_APP_MEDIA_URL;
        return `${mediaUrl}${imagePath.startsWith('/') ? imagePath : `/${imagePath}`}`;
    }

    // Priority 2: Use API base URL and construct media URL (development fallback)
    const apiBaseUrl = process.env.REACT_APP_API_BASE || '';
    if (apiBaseUrl) {
        try {
            const url = new URL(apiBaseUrl);
            const mediaBaseUrl = `${url.protocol}//${url.host}`;
            return `${mediaBaseUrl}${imagePath}`;
        } catch (error) {
            // Fallback to relative path
        }
    }

    // Priority 3: Hardcoded fallback for development
    if (process.env.NODE_ENV === 'development') {
        return `http://localhost:8000${imagePath}`;
    }

    // Priority 4: Fallback to relative path (works if frontend and media are on same domain)
    return imagePath;
}; 